import OrderAttachmentAssignmentStore from "./Store/OrderAttachmentAssignmentStore"

export default {
    namespaced: true,
    modules: {
        assignment: OrderAttachmentAssignmentStore

    }
}
